'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectedDraggableDimensionPublisher = require('./connected-draggable-dimension-publisher');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_connectedDraggableDimensionPublisher).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/draggable-dimension-publisher/index.js
// module id = 3038
// module chunks = 0